<template>
  <el-result
    icon="error"
    title=""
    sub-title="抱歉，您访问的页面不存在或您无权访问此页面。"
  >
    <template #extra>
      <el-button type="primary" @click="backToHome">
        返回首页
      </el-button>
    </template>
  </el-result>
</template>

<script>

export default {
  methods: {
    backToHome() {
      this.$router.push('/v3/person-board')
    }
  },
}
</script>

<style>
</style>
